import type { SticksProductWithAggregations } from "../../../../containers/SticksProductDetailsContainer/types";

export const getAggregationFromLastSingleProduct = (
  packagingPreference: string,
  newPackagingValue: string,
  lastSingleProductSelected?: SticksProductWithAggregations
) => {
  if (
    packagingPreference === "mix_n_match" &&
    newPackagingValue !== "mix_n_match" &&
    lastSingleProductSelected?.aggregations
  ) {
    const aggregation = structuredClone(lastSingleProductSelected.aggregations);
    const { current } = lastSingleProductSelected;
    const { orderFrequency, packagingPreference } = current;

    aggregation[orderFrequency][packagingPreference] = current;

    return aggregation;
  }
  return undefined;
};
